module.exports = __webpack_public_path__ + "img/caselist28.56c9bfaa.jpg";